/**
 * CMES Pharma Intel - Offline Queue Service
 * Queues failed POST/PUT requests when offline, retries on reconnection.
 */

const QUEUE_KEY = "cmes_offline_queue";

export function getOfflineQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]");
  } catch {
    return [];
  }
}

export function addToOfflineQueue(request) {
  const queue = getOfflineQueue();
  queue.push({
    id: Date.now() + "-" + Math.random().toString(36).slice(2, 8),
    url: request.url,
    method: request.method,
    headers: request.headers,
    body: request.body,
    timestamp: new Date().toISOString(),
    retries: 0,
  });
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

export function removeFromQueue(id) {
  const queue = getOfflineQueue().filter((item) => item.id !== id);
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
}

export function clearOfflineQueue() {
  localStorage.removeItem(QUEUE_KEY);
}

export async function syncOfflineQueue(onProgress) {
  const queue = getOfflineQueue();
  if (queue.length === 0) return { synced: 0, failed: 0 };

  let synced = 0;
  let failed = 0;

  for (const item of queue) {
    try {
      const response = await fetch(item.url, {
        method: item.method,
        headers: item.headers,
        body: item.body,
      });
      if (response.ok || response.status < 500) {
        removeFromQueue(item.id);
        synced++;
      } else {
        failed++;
      }
    } catch {
      failed++;
    }
    if (onProgress) onProgress({ synced, failed, total: queue.length });
  }

  return { synced, failed };
}

// Auto-sync when connection is restored
if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    setTimeout(async () => {
      const queue = getOfflineQueue();
      if (queue.length > 0) {
        const result = await syncOfflineQueue();
        if (result.synced > 0) {
          window.dispatchEvent(new CustomEvent("cmes-sync-complete", { detail: result }));
        }
      }
    }, 2000);
  });
}
